import { render } from "./BilletsTable.vue?vue&type=template&id=2cb20c2c"
import script from "./BilletsTable.vue?vue&type=script&lang=js"
export * from "./BilletsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__